import { Modal } from '@shopify/polaris'
import { useChangePlan } from '../../containers/Pricing/hooks'
import useCustomHistory from '../../hooks/useCustomHistory'

const FreeTrialModal = ({ trialExpired, setTrialExpired }) => {
    const [request] = useChangePlan()
    const history = useCustomHistory()

    const changePlan = async  () => {
        await request('Free')
        history.push('/pricing')
      }

    return (
      <Modal
        open={trialExpired === 0}
        onClose={() => setTrialExpired(null)}
        title="Free Trial Ending Soon!"
        primaryAction={{
            content: 'Downgrade to Free',
            onAction: () => changePlan()
        }}
        secondaryActions={[{
            content: 'Keep Current Plan',
            onAction: () => setTrialExpired(null)
        }]}
      >
        <Modal.Section>
          <p>Your trial period ends today. To avoid being charged, please downgrade to the Free plan before it ends.</p>
        </Modal.Section>
      </Modal>
    )
}

export default FreeTrialModal
